"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.error.profession_required': 'Proszę wybrać zawód przed kontynuowaniem',
    'onboarding.error.profession_select_first': 'Proszę najpierw wybrać zawód',
    'onboarding.error.avatar_name_required': 'Nazwa awatara jest wymagana',
    'onboarding.error.avatar_name_provide': 'Proszę podać nazwę awatara',
    'onboarding.error.model_required': 'Przed kontynuowaniem wybierz model AI',
    'onboarding.error.answer_required': 'Odpowiedź jest wymagana',
    'onboarding.error.complete_required_step': 'Proszę ukończyć wymagany krok',
    'onboarding.error.complete_step': 'Proszę ukończyć krok',
    'onboarding.error.before_finishing': 'przed zakończeniem',
    'onboarding.error.professions_load_failed': 'Błąd ładowania zawodów',
    'onboarding.error.professions_load_general': 'Ogólny błąd ładowania zawodów',
    'onboarding.error.steps_load_failed': 'Błąd ładowania kroków',
    'onboarding.error.steps_load_general': 'Ogólny błąd ładowania kroków',
    'onboarding.error.questions_load_failed': 'Błąd ładowania pytań',
    'onboarding.error.questions_load_general': 'Ogólny błąd ładowania pytań',
    'onboarding.error.load_failed': 'Błąd ładowania danych onboardingu',
    'onboarding.error.load_general': 'Ogólny błąd ładowania onboardingu',
    'onboarding.error.save_failed': 'Błąd zapisywania onboardingu',
    'onboarding.error.save_general': 'Ogólny błąd zapisywania onboardingu',
};
